import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import MainCard from './MainCard'

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}), { name: 'AutoInvest' })

export default function AutoInvest() {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      {/* cards */}
      <MainCard />
    </div>
  )
}
